<template>
  <!--      弹框绑定手机-->
  <div > <div class="pop_up_wrap" >
    <!--          <span class="close"></span>-->
    <div class="title"><span>恭喜你，预约成功！</span></div>
    <p class="pop_desc">
      游戏正式上线时将通过以下手机通知你，并为你下载该游戏
    </p>
    <input class="pop_input" v-model="phone" type="text" placeholder="请输入手机号码" />
    <div class="checked_wrap"  v-if="!isIOS">
      <!-- 默认选中，取消加disabled -->
      <span

        :class="{
              'checked_icon_wrap' :true,
              'disabled' : !wifiAutoDownloadDisabled
            }"
        @click="wifiAutoDownloadDisabled = !wifiAutoDownloadDisabled"
      >
              <span class="checked_icon"> </span>
            </span>
      游戏开放下载时，WI-FI环境下自动帮你下载
    </div>
    <!-- 置灰：disabled -->
    <a href="javascript:;"
       @click="submitPhone"
       :class="{
            'btn' : true,
            'disabled' : !phoneFormatIsOk
          }">好的</a>
  </div>  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
export default {
  name: 'CTgclubGameOrderBindPhonePop',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-game-order-bind-phone-pop-',
      wifiAutoDownloadDisabled: true,
      phone: '',
    };
  },
  computed: {
    isIOS() {
      return this.$platform.isIos;
    },
    phoneFormatIsOk() {
      return  /^1[3456789]\d{9}$/.test(this.phone);
    },
  },
  async mounted() {
    console.log('configurationData pop bind phone=', this.configurationData);
    await this.initialize();
  },
  methods: {
    reportBindPhoneFunc(status) {
      if (typeof  this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'bind_phone',
          eventData: {
            status,
          },
        };
        this.reportClickRaw(params);
        console.log('reportFunc bind Phone in order  data =', params);
      }
    },
    async initialize() {},
    async submitPhone() {
      const { inputPhoneFlowId = 0, wifiAutoDownLoadReportId = 0 } = this.configurationData;
      if (!this.phoneFormatIsOk) return;

      const response = await  this.flowRequest({
        flowId: inputPhoneFlowId,
        params: {
          data: JSON.stringify({
            mobile: this.phone.toString(),
          }),
        },
      });
      const { ret, msg, data } = response;
      const { ret: resRet } = data;
      if (ret !== 0 || resRet !== 0) {
        this.$alert({ msg: msg || '操作失败' });
        this.reportBindPhoneFunc('0');
        return ;
      }
      this.hasAccessBindPhone = false;
      this.phone = '';
      console.log('inputPhoneFlowId ', response);
      if (wifiAutoDownLoadReportId > 0 && !this.isIOS) {
        const operType = this.wifiAutoDownloadDisabled ? 1 : 0;
        this.$emit('closeBindOrderPhone',  this.wifiAutoDownloadDisabled);
        this.flowRequest({
          flowId: wifiAutoDownLoadReportId,
          params: {
            data: JSON.stringify({
              operType,
            }),
          },
        }).then((response) => {
          console.log('wifiAutoDownLoadReportId ', response);
        });
      } else {
        this.$emit('closeBindOrderPhone', false);
      }
      this.reportBindPhoneFunc('1');
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
